export const RelatedEntityAttribute: string = 'data-ref';
